export default "__VITE_ASSET__CxHpro9V__"